import styles from './JobWidgetStatus.module.css'
import { Icon, type IconName } from '@/components/Icon'
import { CardTitle } from '@/components/Card'
import { AutoSkeleton, useIsSkeleton } from '@/components/Skeleton'

interface JobWidgetStatusProps {
  title: string
  icon?: IconName
  isSkeleton?: boolean
}

export function JobWidgetStatus({
  icon,
  title,
  isSkeleton,
}: JobWidgetStatusProps) {
  isSkeleton = useIsSkeleton(isSkeleton)

  return (
    <AutoSkeleton isSkeleton={isSkeleton}>
      <div className={styles.content}>
        {icon && <Icon name={icon} variant="surface-active" />}

        <CardTitle>{title}</CardTitle>
      </div>
    </AutoSkeleton>
  )
}
